module.exports = __webpack_public_path__ + "static/media/Icons_right.782fbd4d.svg";